{
  "my_calendar": {
    "upcoming": "À venir",
    "recent": "Récent",
    "calendar": "Calendrier",
    "list": "Liste"
  }
}
